import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { Local, Session } from '@/utils/storage';
import { ElMessage } from 'element-plus';
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/homepage/HomeView.vue'),
    children: [
      {
        path: '/article-detail',
        name: 'article-detail',
        component: () => import('@/views/homepage/articleDetail.vue')
      }
    ]
  },
  {
    path: '/publish-article',
    name: 'publish-article',
    component: () => import('@/views/publishArticle/publishArticle.vue')
  },
  {
    path: '/personal-center',
    name: 'personal-center',
    component: () => import('@/views/personalCenter/index.vue')
  },
  {
    path: '/personal-center',
    name: 'personal-center',
    component: () => import('@/views/personalCenter/index.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/userAgreementPrivacyPolicy/index.vue')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/help.vue')
  },
  {
    path: '/:path(.*)*',
    name: 'notFound',
    component: () => import('@/views/notFound/404.vue')
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const token = Session.get('token');
  if ((to.path === '/publish-article' || to.path === '/personal-center') && !token) {
    Session.clear();
    Local.clear();
    ElMessage.error('请先登录用户');
    next(`/`);
  } else {
    next();
  }
});
export default router;
